/**
 * Custom HTTP headers used by the SPA when calling the API.
 *
 * When set to "true" on a request, the shared axios response interceptor skips
 * dispatching the global upgrade modal on 402 — the caller handles the error
 * inline (e.g. AI instructions quality check for free users).
 */
export const SUPPRESS_UPGRADE_MODAL_HEADER = 'X-Suppress-Upgrade-Modal';
